import { getEnabledFeatures } from './getEnabledFeatures'

export async function hasFeaturePermissionList(hoaID, permissionName) {
  const results = await getEnabledFeatures(hoaID)

  let permissionSet = false

  if (results !== undefined && results) {
    Array.from(results).forEach(r => {
      if (r) {
        if (r === permissionName) {
          permissionSet = true
        }
      }
    })
  }

  return permissionSet
}
